import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';

import ResourceNotifications from 'app/src/components/Notifications/Resource';
import {
  LinkContainer,
  LinkSpace,
  SubNavContainer
} from 'app/src/elements';

// const SubNavBarContainer = styled(View)`
//   display: flex;
//   flex-direction: row;
//   flex: 0.25;
//   align-items: center;
//   height: 5px;
//   background-color: ${elLightGray};
//   padding: 15px;
//   padding-left: 50px;
// `;

const SubNav = ({
  sellerId,
  sellerName,
  assetId,
  asset,
  vin
}) => {
  const location = useLocation();
  return (
    <SubNavContainer>
      {getLinks()}
    </SubNavContainer>
  )

  function getLinks() {
    return (
      <LinkContainer>
        <Link to={`/sellers/${sellerId}`}>
          <Text><b>{sellerName}</b></Text>
        </Link>
        <LinkSpace />
        {location.pathname.includes('edit') &&
          <View>
            <Link to={`/sellers/${sellerId}/assets/${assetId}`}>
              <Text>{vin}</Text>
            </Link>
          </View>
        }
        {!location.pathname.includes('edit') &&
          <View>
            <Link to={`/sellers/${sellerId}/assets/${assetId}/edit`}>
              <Text>edit</Text>
            </Link>
          </View>
        }
        {asset && (
          <>
            <LinkSpace />
            <View>
              <ResourceNotifications resource={asset} labeled />
            </View>
          </>
        )}
      </LinkContainer>
    )
  }
}

export default SubNav;
